// -- Imports -- //
const onbrandFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrand_scss = require('./onbrand.scss'); //Onbrand styles
const client_scss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');
const onbrandUtilities = require('./onbrandUtilities.js'); //helper functions for dev
// -- Startup -- //
production ? null : onbrandUtilities(devOptions);
$('body').prepend(htmlHeader);
$('body').append(htmlFooter);
window.onbrandLoaded = false;
onbrandFunctions.fixShareWidgetImproved();

//For conditional display of article rating system... leave me here.
var $starWidget = $('#starWidget');

// -- Custom Functions -- //

window.onbrand.addBanner = function(settings) {
  var defaults = {
    stream: 'noStreamSelected',
    youtubeVideoLink: 'https://www.google.ca',
    headingText: 'input your heading here!',
    backgroundImage: false,
    buttonColor: false,
    buttonHoverColor: false,
  };
  var finalSettings = Object.assign(defaults, settings);

  if ($('body').hasClass(finalSettings.stream)) {
    $('#bannerVideoLink').attr('href', finalSettings.youtubeVideoLink);
    $('#bannerVideoHeading').html(finalSettings.headingText);
    if (
      (finalSettings.buttonColor ||
        finalSettings.buttonHoverColor ||
        finalSettings.backgroundImage) &&
      $('#' + finalSettings.stream + '-bannerStyles').length === 0
    ) {
      $('head').append(
        '<style id="' +
          finalSettings.stream +
          '-bannerStyles">body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button, body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button:before, body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button:after {background: ' +
          finalSettings.buttonColor +
          ' !important;} body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button:hover, body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button:hover:before, body.' +
          finalSettings.stream +
          ' .heroVideoContainer .heroText button:hover:after {background: ' +
          finalSettings.buttonHoverColor +
          ' !important;}  ' +
          (finalSettings.backgroundImage
            ? 'body.' +
              finalSettings.stream +
              ' .heroVideoContainer .videoOverlay { background-image: url("' +
              finalSettings.backgroundImage +
              '") !important; } '
            : '') +
          '</style>'
      );
    }
  }
};

window.onbrand.initBanners = function() {
  buildVideo();
  window.onbrand.banners.forEach(function(bannerSetting) {
    window.onbrand.addBanner(bannerSetting);
    Hubs.Events.on(
      'pageChange',
      window.onbrand.addBanner.bind(this, bannerSetting)
    );
  });
};

//Deprecated, use initBanners
var swapVideoForStream = function() {
  if ($('body').hasClass('stream-885062')) {
    $('#bannerVideoLink').attr(
      'href',
      'https://www.youtube.com/watch?v=4lrqfx555CI&feature=youtu.be '
    );
    $('#bannerVideoHeading').html(
      'The Future of <span class="brand2">Digital Health</span>'
    );
  } else if ($('body').hasClass('stream-1009665')) {
    $('#bannerVideoLink').attr('href', '');
    $('#bannerVideoHeading').html(
      'CONNECT WITH US ON LINKEDIN, TWITTER AND FACEBOOK'
    );
  } else if ($('body').hasClass('stream-1050790')) {
    $('#bannerVideoLink').attr(
      'href',
      'https://www.youtube.com/watch?v=_lPQsoxPGm8&feature=youtu.be'
    );
    $('#bannerVideoHeading').html('THE FUTURE OF WHOLE PERSON CARE ');
  } else {
    $('#bannerVideoLink').attr('href', '//youtu.be/947THL4EOXE');
    $('#bannerVideoHeading').html('The Future Of Mental Health');
  }
};

var buildVideo = function() {
  console.log('building video...');
  var $hero = $('<section class="heroVideoContainer"></section>');
  // $hero.append('<video src="#"></video>');
  $hero.append('<div class="videoOverlay"></div>');
  $hero.append(
    '<div class="heroText"><h1 id="bannerVideoHeading">The Future Of Mental Health</h1><a id="bannerVideoLink" href="//youtu.be/947THL4EOXE" data-lity><button>Play Video <i class="fa fa-play-circle"></i></button></a> </div>'
  );
  $hero.append('<i id="heroArrow" class="fa fa-angle-down"></i>');
  $hero.insertAfter('.top-nav');

  $('#heroArrow').on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    $('html').animate(
      { scrollTop: $('.tile:first-of-type').offset().top - 10 + 'px' },
      600
    );
  });
  // swapVideoForStream();
  // Hubs.Events.on('pageChange', swapVideoForStream);
};

var highResImages = function(tile) {
  var $highResTile = $(tile)
    .not('.tile[data-id="377063308"]')
    .not('.tile[data-id="378984445"]')
    .children('.img')
    .children('img');
  if ($highResTile.length) {
    var check = $highResTile.attr('src').split('url=')[1];
    var partialDecode = decodeURIComponent(
      $highResTile.attr('src').split('url=')[1]
    );
    if (!check) {
      return;
    }
    var lastLayer = partialDecode.split('url=')[1];
    if (lastLayer === undefined) {
      $highResTile.attr('src', partialDecode.split('&')[0]);
    } else {
      console.log('else');
      var newSRC = decodeURIComponent(lastLayer).split('&')[0];
      $highResTile.attr('src', newSRC);
    }
  }
};

var customBlogTiles = function() {
  //Rod's blog
  $('.tile').each(function(index, el) {
    var tags;
    var that = this;
    if ($(this).attr('data-tags')) {
      tags = $(this)
        .attr('data-tags')
        .split(',');
      tags.forEach(function(tag) {
        if (tag.toLowerCase() === 'rod') {
          highResImages(that);
          $(that).addClass('customBlogTile');
          // $(that).find('.view.item-link').text('Read Post') - No longer wanted
          // var $descriptionText = $(that).find('.description h4');
          // var fullDesc = $descriptionText.text();
          // var shortDesc = fullDesc.split(' ').slice(0,9).join(' ') + '...';
          // $descriptionText.text(shortDesc);
          $;
        }
      });
    }
  });
};
var addFATriangles = function() {
  $('.tile.single>a.view').each(function(index, el) {
    if ($(this).children('span.fa.fa-chevron-right').length === 0) {
      var currentText = $(this).text();
      $(this).html(
        '<span class="currentText" >' +
          currentText +
          '</span> <span class="fa fa-chevron-right"></span>'
      );
    }
  });
};
var buildQuoteCTA = function() {
  var $cta = $('#hub-cta-81763');
  if ($cta.length) {
    var ctaText = $cta
      .children('p')
      .text()
      .split('-');
    var quoteText = ctaText[0].trim().slice(1);
    quoteText = '<span class="quoteIcon">\u201C</span>' + quoteText;
    var quoteAuthor = ctaText[1].trim();
    var quoteAuthorSub = ctaText[2].trim();

    $cta.children('p').html(quoteText);
    const $quoteAuthor = $('<p class="quoteAuthor"></p>');
    $quoteAuthor.text(quoteAuthor);
    $quoteAuthor.html(
      $quoteAuthor.html() +
        '<br><span class="authorSub">' +
        quoteAuthorSub +
        '</span>'
    );
    $cta.append($quoteAuthor);
  }
};

//Add special text based on tags
var inTheNewsFlag = function() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.newsChecked)')
    .not('.cta')
    .each(function(index, el) {
      var target = $(this)
        .children('a')
        .data();
      if (target) {
        var hasTag = false;
        if ($(this).attr('data-tags')) {
          var tags = $(this)
            .attr('data-tags')
            .split(',');
          tags.forEach(function(tag) {
            if (tag.toLowerCase() === 'in the news') {
              hasTag = true;
            }
          });
        }

        if (!target.internal || hasTag) {
          $(this)
            .find('.h3like')
            .html(
              '<span class="inTheNews">In The News <i class="fa fa-external-link"></i><br></span>' +
                $(this)
                  .find('.h3like')
                  .html()
            );
          // $(this).children('a').each(function(index, el) {
          //   $(this).attr('target', '_blank').off('click');
          // });
        }
      }
      $(this).addClass('newsChecked');
    });
};

var audioFlag = function() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.audioChecked)')
    .not('.cta')
    .each(function(index, el) {
      var hasTag = false;
      if ($(this).attr('data-tags')) {
        var tags = $(this)
          .attr('data-tags')
          .split(',');
        tags.forEach(function(tag) {
          if (tag.toLowerCase() === 'audio clip') {
            hasTag = true;
          }
        });
      }

      if (hasTag) {
        $(this)
          .find('.h3like')
          .html(
            '<span class="inTheNews">Audio Clip <i class="fa fa-volume-up "></i><br></span>' +
              $(this)
                .find('.h3like')
                .html()
          );
        // $(this).children('a').each(function(index, el) {
        //   $(this).attr('target', '_blank').off('click');
        // });
      }
      $(this).addClass('audioChecked');
    });
};

var videoFlag = function() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.videoChecked)')
    .not('.cta')
    .each(function(index, el) {
      var hasTag = false;
      if ($(this).attr('data-tags')) {
        var tags = $(this)
          .attr('data-tags')
          .split(',');
        tags.forEach(function(tag) {
          if (tag.toLowerCase() === 'watch video') {
            hasTag = true;
          }
        });
      }

      if (hasTag) {
        $(this)
          .find('.h3like')
          .html(
            '<span class="inTheNews">Watch Video <i style="font-size: 15px;" class="fa fa-play-circle "></i><br></span>' +
              $(this)
                .find('.h3like')
                .html()
          );
        // $(this).children('a').each(function(index, el) {
        //   $(this).attr('target', '_blank').off('click');
        // });
      }
      $(this).addClass('videoChecked');
    });
};

var starWidgetItemLevel = function() {
  if ($('body').hasClass('single-page')) {
    $starWidget.remove();
    $('.entry-wrapper').append($starWidget);
  } else {
    $('body').append($starWidget);
  }
};

var nextItemFlyoutNewTab = function() {
  $('.item-next-prev a')
    .attr({ target: '_blank', 'data-internal': 'false' })
    .removeClass('hooked')
    .off();
};

//Add special text based on [External] being in title
var externalLinkTitle = function() {
  var testFor = /\[EXTERNAL\]/gi;
  $('.tile')
    .not('.externalLink')
    .each(function(index, el) {
      var $h3 = $(this).find('.description .h3like');
      var testMe = $(this)
        .find('.description .h3like')
        .text();
      if (testFor.test(testMe)) {
        var newText = testMe.replace(testFor, '');
        console.log(newText);
        $(this)
          .find('.description .h3like')
          .text(newText);
        $(this).addClass('externalLink');
        $(this)
          .find('a')
          .attr('target', '_blank')
          .removeClass('hooked')
          .off();
      }
    });
  $('.item-next-prev').each(function(index, el) {
    var $a = $(this).find('a');
    var that = this;
    $a.each(function(index, el) {
      if (testFor.test($(this).attr('data-page-title'))) {
        $(this)
          .text(
            $(this)
              .text()
              .replace(testFor, '')
          )
          .attr('target', '_blank')
          .removeClass('hooked')
          .off();
        $(this)
          .siblings('.preview')
          .find('.title')
          .text(
            $(this)
              .siblings('.preview')
              .find('.title')
              .text()
              .replace(testFor, '')
          );
      }
    });
  });
};

const customNavigationHandler = () => {
  const topNav = $('.top-nav').clone();
  const parent =
  `
    <div id="custom-dropdown" class="custom-dropdown">
      <ul>
        <li class="dropdown-parent">
          <span class="dropdown-icon"></span>
        </li>
      </ul>
    <div>
  `;

  const subMenu = topNav.find('.left-nav')
    .attr('class', 'dropdown-submenu')
    .clone();

  subMenu
    .find('li')
    .removeClass()
    .find('a')
    .removeClass();

  const share = topNav
    .find('.relativeDiv--share')
    .clone();

  if ($('body').hasClass('stream-2437559') && ($('body #custom-dropdown').length === 0)) {
    $('#injected-header header .top.grid:not(.chart)').append(parent);
    $('#injected-header .dropdown-parent').append(subMenu);
    $('.custom-dropdown').prepend(share);
  }

  const menuToggle = $('.dropdown-parent');
  const menuOpen = 'menu-open';
  const shareToggle = $('.relativeDiv--share');
  const shareOpen = 'share-open';

  // Wait for share-hub to render, then check and remove it
  setTimeout(() => {
    if ($('#custom-dropdown .share-hub').length > 0) {
      $('#custom-dropdown .share-hub').remove();
    }
  }, 200);

  if ($('#custom-dropdown .share-container').length > 1) {
    $('#custom-dropdown .share-container').not(':first').remove();
  }

  menuToggle.off();
  menuToggle.on('click', (e) => {
    $('body').toggleClass(menuOpen);
  });

  shareToggle.off();
  shareToggle.on('click', () => {
    shareToggle.toggleClass(shareOpen);
  });

  if ($('body').hasClass(menuOpen)) {
    $('body').removeClass(menuOpen);
  }
};

const limitTileDesc = function limitTileDesc() {
  const elem = $('body');
  const length = 15;
  const trailingDots = '...';

  if (elem.hasClass('listing-page') && elem.hasClass('stream-2437559')) {
    const tile = $('.tile:first-of-type');
    const descElem = tile.find('.long-h3');
    const oldDesc = descElem.text().split(' ');

    const newDesc = oldDesc
      .slice(0, length)
      .map((word) => {
        return word;
      })
      .join(' ') + trailingDots;

    descElem.text(newDesc);
  }
};

// OB-1637 

const removeVideoFromAuthorsPage = () => {
  const pageIdentifier = document.querySelector('#page-type-identifier');
  const body = document.querySelector('body');
  if (pageIdentifier.dataset.pageType === "PAGE_TYPE_AUTHOR") {
    body.classList.add('author-page');
  }
};

// -- Hub Events -- //
const onLoadAndPageChange = function() {
  onbrandFunctions.blockCtaFix();
  onbrandFunctions.fadeOutItem();
  starWidgetItemLevel();
  customBlogTiles();
  buildQuoteCTA();
  addFATriangles();
  highResImages('.tile:first-of-type');
  externalLinkTitle();
  inTheNewsFlag();
  audioFlag();
  videoFlag();
  customNavigationHandler();
  limitTileDesc();
  removeVideoFromAuthorsPage();
};
Hubs.Events.on('load', function() {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();
    // fixShareWidget();
    // Add your onloads here...
    window.onbrand.initBanners();
    // end your onloads before here...
    window.onbrandLoaded = true;
  }
})
  .on('pageChange', function() {
    onLoadAndPageChange();
  })
  .on('itemsLoaded', function(itemIds, selectors) {
    externalLinkTitle();
    inTheNewsFlag();
    audioFlag();
    videoFlag();
  })
  .on('resize', function() {
    // sideCtaFix();
    addThisFix();
  })
  .on('scroll', function() {
    // sideCtaFix();
    addThisFix();
    onbrandFunctions.blockCtaFix();
    onbrandFunctions.fadeOutItem();
  })
  .on('ctaActivate', function(ctaId) {})
  .on('ctaFormSubmitSuccess', function(ctaId, mappedData, ctaName) {})
  .on('search', function() {});

//The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger('load');
}



// WEBPACK FOOTER //
// ./onbrand.js